import styled from "styled-components";
import { motion } from "framer-motion";

export const ModalOverlay = styled.div`
  position: fixed;
  top: 0; left: 0;
  width: 100vw; height: 100vh;
  background: rgba(0, 0, 0, 0.4);
  display: flex;
  align-items: center;
  justify-content: center;
  z-index: 2000;
`;

export const ModalBox = styled(motion.div)`
  background: ${({ theme }) => theme.inputBg};
  padding: 32px;
  border-radius: 20px;
  text-align: center;
  width: 100%;
  max-width: 500px;
  color: ${({ theme }) => theme.text};
  box-shadow: 0 4px 12px rgba(0,0,0,0.2);

  @media (max-width: 600px) {
    padding: 24px 16px;
    border-radius: 16px;
  }
`;

export const Emojis = styled.div`
  font-size: 32px;
  margin: 20px 0;
  display: flex;
  justify-content: space-around;
  position: relative;
`;

export const ButtonRow = styled.div`
  display: flex;
  justify-content: center;
  gap: 12px;
  flex-wrap: wrap;
  margin-top: 16px;
`;

export const ActionButton = styled.button`
  background: ${({ theme }) => theme.bubbleAgent || "#4a90e2"};
  color: ${({ theme }) => (theme.text === "#f1f1f1" ? "#fff" : "#111")};
  border: none;
  padding: 10px 20px;
  border-radius: 12px;
  font-weight: bold;
  font-size: 14px;
  cursor: pointer;
  transition: opacity 0.2s ease;

  &:hover {
    opacity: 0.9;
  }

  &:focus {
    outline: 2px solid ${({ theme }) => theme.text};
    outline-offset: 2px;
  }
`;
